export default __webpack_public_path__ + "static/media/pflanding.92d806dd.png";